import { of as observableOf, Observable } from "rxjs";

import { catchError, map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute,
  CanLoad
} from "@angular/router";

import { SessionService } from "../_services/session.service";

@Injectable()
export class ScrapingGuard implements CanActivate {
  constructor(private router: Router, private sessionService: SessionService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log("Routing");
    let token: string = localStorage.getItem("scraping_token");
    if (token && !this.sessionService.tokenExpiro(token)) return true;

    return this.sessionService.getScrapingAccessToken().pipe(
      map(respuesta => {
        if (respuesta.Data && respuesta.Data.access_token) {
          localStorage.setItem("scraping_token", respuesta.Data.access_token);
          return true;
        }
        return false;
      }),
      catchError(() => {
        this.router.navigate(["/NoConnection"], {
          queryParams: { returnUrl: state.url }
        });
        return observableOf(false);
      })
    );
  }

}
